import { authConstants } from '../Constants'
const authReducer = (state = false, action) => {
	switch (action.type) {
		case authConstants.LOGIN_SUCCESS:
			return action.payload;
		case authConstants.LOGOUT:
			localStorage.clear();
			return false;
		default:
			return state;
	}
}

export default authReducer;